class AnimateOnScroll {

  constructor() {

    this.debug = window.location.search == "?debug" ? true : false;
    this.scrollAnims = [];
    // this.debug = true;
  }

  init() {

    let _self = this;


    _self.elements = $('.animate-on-scroll');
    if(_self.debug) console.log('ParallaxEffect parallaxes?', parallaxes);

    if(_self.elements.length) {

      _self.elements.each(function(i,element){

        let scrollAnimTrigger = ScrollTrigger.create({
          markers: _self.debug,
          // markers: true,
          id: 'scrollAnimTrigger-'+i,
          trigger: element,
          start: "top bottom-=45%",
          end: "bottom top",
          // onToggle: self => {},
          // onUpdate: self => progressTo(self.progress),
          onEnter: self => { $(element).addClass('animate'); },
          // onEnterBack: self => { console.log('onEnterBack '+i); $(element).addClass('animate'); },
          // onLeave: function(){ console.log('onLeave '+i); $(element).removeClass('animate'); },
          // onLeaveBack: function(){ $(element).removeClass('animate'); },
        });

        _self.scrollAnims.push(scrollAnimTrigger);

      });

    }

    window.AnimateOnScroll = this;
  
  }

}

export { AnimateOnScroll };